import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import {
  getGpSamplingAssignmentQueries,
  GP_ASSIGNMENT_CONFIG,
  SamplingAssignmentMapPage,
} from '@sampling';

export const Route = createFileRoute('/_app/_admin/gp-sampling-assignment')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.WipPages);
  },
  loader: async ({ context }) => {
    const queries = getGpSamplingAssignmentQueries();
    await context.queryClient.prefetchQuery(queries.map());
  },
  component: () => <SamplingAssignmentMapPage config={GP_ASSIGNMENT_CONFIG} />,
});
